/* Rquiere de mixin.js */

var typeLegalDocument = {
	data () {
		return {
			listTypeLegalDocuments: [
                {id: 33, name: 'FACTURA ELECTRONICA', syntetic: 'FACTELEC', weGenerate: '1', needReference: 0},
                {id: 39, name: 'BOLETA ELECTRONICA', syntetic: 'BOLELEC', weGenerate: '1', needReference: 0},
                {id: 52, name: 'GUIA DE DESPACHO ELECTRONICA', syntetic: 'GDESELEC', weGenerate: '1', needReference: 0},
                {id: 61, name: 'NOTA DE CREDITO ELECTRONICA', syntetic: 'NCELEC', weGenerate: '1', needReference: 1},
            ],
			methodsTypeLegalDocument: {
                create: 'typeLegalDocument/register',
				get: 'typeLegalDocuments',
				show: 'typeLegalDocument/',
			},
			paginationTypeLegalDocuments: [],
			searchTypeLegalDocuments: '',
			searchingTypeLegalDocument: false,
            objectTypeLegalDocument: {
                exists: 0,
                id: 0,
                name: '',
                syntetic: '',
                weGenerate: 0,
                needReference: 0,
            },
		}
	},
	methods:{
		getAllTypeLegalDocuments(page = 1) {
            this.listTypeLegalDocuments = []
            this.searchingTypeLegalDocument = true
            let url = this.getApiBackend + this.methodsTypeLegalDocument.get
			this.axiosActionIS(url, 'GET', 'getAllTypeLegalDocumentsResult')
        },
        getAllTypeLegalDocumentsResult(response) {
            this.searchingTypeLegalDocument = false
            if(response.data.success) {
                this.listTypeLegalDocuments = response.data.data
                this.paginationTypeLegalDocuments = response.data.paginate
            } else {
                this.$snotify.error('Problema al tratar de rescatar los documentos legales', 'Error')
            }
            this.getAllTypeLegalDocumentsResultLocal(response)
        },
        getAllTypeLegalDocumentsResultLocal(response) {
            console.log('getAllTypeLegalDocumentsResult no desarrollado', response)
        },
        clearObjectTypeLegalDocument() {
            this.objectTypeLegalDocument.exists = 0
            this.objectTypeLegalDocument.id = 0
            this.objectTypeLegalDocument.name = ''
            this.objectTypeLegalDocument.syntetic = ''
            this.objectTypeLegalDocument.weGenerate = 0
            this.objectTypeLegalDocument.needReference = 0
        },
	},
};

export default typeLegalDocument;